import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Highlighter from 'react-highlight-words';
import { withLocalize } from 'react-localize-redux';
import IconMobile from 'resources/svg/icon_mobile.svg';
import Label from '../../../components/foundations/Label';
import Tooltip from '../../../components/molecules/Tooltip';
import { getPlatformIcon } from '../../../utils/OS';
import { getTranslatedItemType, isPartialSelection } from '../../utils';
import css from './AppWithSitesItem.css';

const AppWithSitesItem = ({ item, search, translate }) => {
    const selectedCount = item.sites.length;
    const totalCount = item.totalSites || item.sites.length;

    return (
        <div className={css.appWithSites}>
            {item.icon ? (
                <img src={item.icon} alt="" className={css.appIcon} />
            ) : (
                <IconMobile className={css.fallbackIcon} />
            )}
            <div className={css.mainInfo}>
                <span className={css.appName}>
                    <Highlighter searchWords={[search]} textToHighlight={item.displayName} autoEscape />
                </span>
                <Label
                    className={classNames(css.sitesCounter, {
                        [css.partialSelection]: isPartialSelection(selectedCount, totalCount),
                    })}
                    type="p"
                    text={translate('STATIC.PAGES.TEAM_MEMBERS.MANAGE_PERMISSIONS_PAGE.ITEM_SELECTED', {
                        selected: selectedCount,
                        total: totalCount,
                        itemType: getTranslatedItemType(translate, 'appsites'),
                    })}
                />
            </div>
            {item.sites && item.sites.length > 0 && (
                <div className={css.siteIcons}>
                    {item.sites.map(site => {
                        const PlatformIcon = getPlatformIcon(site.platform);
                        return (
                            <Tooltip key={site.name} title={site.name}>
                                <PlatformIcon className={css.siteIcon} />
                            </Tooltip>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

AppWithSitesItem.propTypes = {
    search: PropTypes.string,
    translate: PropTypes.func.isRequired,
    item: PropTypes.shape({
        icon: PropTypes.string,
        displayName: PropTypes.string,
        totalSites: PropTypes.number,
        sites: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                platform: PropTypes.string,
            })
        ),
    }),
};

export default withLocalize(AppWithSitesItem);
